export default "__VITE_ASSET__BAkysOqx__"